import { Col, Row } from 'antd';
import clsx from 'clsx';
import Box from 'components/Box';
import Text from 'components/Text';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';

export const TicketBox = styled.div`
  border-radius: 20px;
  background: #fff;
  width: 20.5rem;
  height: fit-content;
`;

export const ContainerStyled = styled.div`
  background-color: #e5e5e5;
  height: 100vh;
  position: relative;
  flex-grow: 1;
  width: 100%;
  overflow: auto;
`;

export const LogoBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1px;
  text-align: center;
`;

export const ShopName = styled.div`
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 2px;
  color: black;
`;

export const ShopAddress = styled.div`
  font-size: 14px;
  margin-bottom: 2px;
  color: black;
`;

export const ShopPhone = styled.div`
  font-size: 14px;
  margin-bottom: 2px;
  color: black;
`;

export const Header = styled(Row)`
  border-top:1px solid black;
  border-bottom: 1px dashed black;
`;

export const ColHeader = styled(Col)`
    color:  black;
    padding: 1px 0px;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

export const Discount = styled(Header)`
  border-top: unset;
`;

export const BoxInfo = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.bb {
        border-bottom: 1px dashed black;
    }
`;

export const DividerSlit = styled.div`
border-bottom: 1px dashed black;
margin: 1rem -16px;
`;
type IPayrollComponentProps = {
  label?: string | undefined;
  amount?: string | number | undefined;
  className?: string;
  style?: React.CSSProperties;
};
export type IPayrollComponent = ({ label, amount, className }: IPayrollComponentProps) => JSX.Element;

export const ReportPayrollPaymentRow: IPayrollComponent = ({ label, amount, className }: IPayrollComponentProps) => {
  return (
    <BoxInfo className={clsx('bb item-payroll-row ReportPayrollPaymentRow', className)}>
      <Text textTransform='capitalize' printMode variant='CAPTION_2' color="text_3" className='payroll-label'>
        {label}
      </Text>
      <Text printMode variant='CAPTION_2' color="text_3" className='payroll-value' >
        {typeof amount == 'string' ? amount : formatCurrency(amount || '')}
      </Text>
    </BoxInfo>
  );
};

export const ReportPayrollTitleRow: IPayrollComponent = ({ label, amount, className }: IPayrollComponentProps) => {
  return (
    <Discount className={clsx('item-payroll-row ReportPayrollTitleRow', className)}>
      <ColHeader span={17}><Text printMode variant='CAPTION_2' className='payroll-label' >{label}</Text></ColHeader>
      <ColHeader span={7} style={{ textAlign: 'end' }}><Text printMode variant='CAPTION_2' className='payroll-value'>{
        typeof amount == 'string' ? amount : formatCurrency(amount || '')
      }</Text></ColHeader>
    </Discount>
  );
};

export const ReportPayrollTipFeeRow: IPayrollComponent = ({ label, amount, className }: IPayrollComponentProps) => {
  return (
    <Discount className={clsx('item-payroll-row ReportPayrollTipFeeRow ', className)}>
      <ColHeader flex={1}><Text printMode variant='CAPTION_2' className='payroll-label' >{label}</Text></ColHeader>
      <ColHeader span={7} style={{ textAlign: 'end' }}><Text printMode variant='CAPTION_2' className='payroll-value'>{typeof amount == 'string' ? amount : formatCurrency(amount || '')}</Text></ColHeader>
    </Discount>
  );
};
export const ReportPayrollCaption3Row: IPayrollComponent = ({ label, amount, className }: IPayrollComponentProps) => {
  return (
    <BoxInfo className={clsx('item-payroll-row ReportPayrollCaption3Row', className)}>
      <Text textTransform='capitalize' printMode variant='CAPTION_3' color="text_3" className='payroll-label'>
        {label}
      </Text>
      <Text printMode variant='CAPTION_3' color="text_3" className='payroll-value'>
        {typeof amount == 'string' ? amount : formatCurrency(amount || '')}
      </Text>
    </BoxInfo>
  );
};

export const ReportPayrollCaption2Row: IPayrollComponent = ({ label, amount, className, style }: IPayrollComponentProps) => {
  return (
    <BoxInfo className={clsx('item-payroll-row ReportPayrollCaption2Row', className)} style={style}>
      <Text textTransform='capitalize' printMode variant='CAPTION_2' color="text_3" className='payroll-label' >
        {label}
      </Text>
      <Text printMode variant='CAPTION_2' color="text_3" className='payroll-value'>
        {typeof amount == 'string' ? amount : formatCurrency(amount || '')}
      </Text>
    </BoxInfo>
  );
};


export const ReportPayrollCaption2HighLightRow: IPayrollComponent = ({ label, amount, className }: IPayrollComponentProps) => {
  return (
    <Box className={clsx('space-between item-payroll-row ReportPayrollCaption2HighLightRow', className)} highlight>
      <Text printMode variant="CAPTION_2" className='title-highlight payroll-label'>
        {label}
      </Text>
      <Text printMode variant="CAPTION_2" className='title-highlight payroll-value'>
        {typeof amount == 'string' ? amount : formatCurrency(amount || '')}
      </Text>
    </Box>
  );
};


